const {
  ADMIN_ROLES,
  CONFIRMATION_TOKEN_URL_PARAM,
  RESET_PASSWORD_TOKEN_URL_PARAM,
} = require('acces-impot-utils/lib/user')

module.exports = {
  ADMIN_ROLES,
  confirmationTokenUrlParam: CONFIRMATION_TOKEN_URL_PARAM,
  resetPasswordTokenUrlParam: RESET_PASSWORD_TOKEN_URL_PARAM,

  // Need to validate before storing in database because of the encoding on User.beforeCreate
  getInvalidPasswordError(password) {
    return [/[a-z]/, /[A-Z]/, /[0-9]/].some(regex => !regex.test(password))
      ? 'errors.passwordInvalid'
      : null
  },
}
